export default __webpack_public_path__ + "static/media/icon_pedidos_acompanhamento.74346f92.svg";